<div class="container">
    <div class="row">
        <div class="col">
        </div>
        <div class="col-8">
            <h1>Manage the "About" Text</h1>
            <form [formGroup]="myForm" (ngSubmit)="saveChanges()">
                <input type="text" id="keyAbout" formControlName="keyAbout"/>
                <div class="form-group">
                    <label for="lang">Language</label>
                    <input type="text" class="form-control" id="lang" placeholder="Type the language code" formControlName="lang"/>
                  </div>
                <angular-editor formControlName="aboutContent" [config]="editorConfig"></angular-editor>
                <div class="form-footer">
                    <button type="submit" class="btn btn-block login_btn">Save it</button>
                </div> 
            </form> 
        </div>
        <div class="col">
        </div>
    </div>
</div>
